const API_BASE = process.env.REACT_APP_API_BASE;

export async function fetchRotaData(propertyId, { start, end }) {
  const res = await fetch(`${API_BASE}/app/API/rbmgt/get_rota_data.php?property_id=${propertyId}&start_date=${start}&end_date=${end}`);
  return await res.json();
}
